import { Component } from '@/app/pkg/component';
type TypeSettings = {};
/**
 * Xuất hiện Outline border khi Atom hover
 */
export class Outline extends Component {
  public $el: JQuery;
  public data = {} as TypeSettings;

  /** constructor
   * @param element DOM
   * @param options Seting
   */
  constructor(element: HTMLElement, options?: TypeSettings) {
    // init everthing
    super();
    this.$el = jQuery(element); // merge element to $el
    if (options) {
      // Merge options to data
      this.mergeData(options);
    }

    // apply functions
    if ((this.$el as any).data('gfoutline') != undefined) {
      (this.$el as any).data('gfoutline').initOutline();
      (this.$el as any).data('gfoutline').applyOutline();
    } else {
      (this.$el as any).gfOutline();
    }
  }
}
